<template>

    <!-- Page Sidebar Ends-->
      <div class="container-fluid front_header">
            <div class=" ">
              <div class="row">
                <div class="col-12">
                <img class="img-fluid for_logo" src="../../../assets/images/logo/hcelogo.png"
                                    alt="looginpage">
                </div>
              </div>
            </div>
          </div>
    <div class="page-body"> 
        <div class="container-fluid">
            <div class="user-profile social-app-profile">
            


                <div class="tab-pane  " id="photos" role="tabpanel" aria-labelledby="photos" v-if="past_visits.length>0">
                    <div class="row mb-5"> 
                      <div class="col-sm-12"  v-for="(item ,index)  in past_visits" :key="item.id">
                            <div class="card">
                              <div class="card-body">
                                <div class="new-users-social mb-0 ">
                                  <div class="d-flex "> 
                                    <div class="flex-grow-1"> 
                                      <!--<h6 class="mb-0 f-w-700">{{item.name}} </h6>-->
                                      <p> Schedule Date : <b>{{item.schedule_date}} </b></p> 
                                    </div>
                                    <span class="pull-right mt-0"> <i data-feather="more-vertical"></i></span>
                                    <span v-if="item.checkout_approval==1 && item.check_out==null" class="badge badge-pill badge-warning text-white">
                                                                      Check Out Approved
                                                              </span>
                                                              <span v-else-if="item.check_out!=null" class="badge badge-pill badge-success text-white">
                                                                      Checked Out
                                                              </span>
                                                              <span v-else-if="item.check_in!=null" class="badge badge-pill badge-info text-white">
                                                                      Checked In
                                                              </span>
                                                              <span v-else-if="item.checkout_approval==2" class="badge badge-pill badge-warning text-white">
                                                                      Check Out Denied
                                                              </span>
                                                              <span v-else-if="item.approval_status==0" class="badge badge-pill badge-warning text-white">
                                                                      Pending
                                                              </span>
                                                              <span v-else-if="item.approval_status==1" class="badge badge-pill badge-success text-white">
                                                                      Accepted
                                                              </span>
                                                              <span v-else-if="item.approval_status==2" class="badge badge-pill badge-danger text-white">
                                                                      Denied
                                                              </span>
  
                                   
                                  </div>
                                </div> 
                                <div class="timeline-content">
                                  <span > Purpose : <b>{{item.purpose}}</b></span>
                                  <br>
                          <div> Staff To Meet : <b>{{item.whom_name}}</b></div>
                                  <div v-if="item.meeting_room"
                                                                  class="badge rounded-pill badge-Info ">Meeting Schedule : {{ item.meeting_room
                                                                  }}</div>
                                  <div class="social-chat">
                                     
                                    <div class="your-msg"  v-if="item.check_in">
                                      <div class="d-flex">
                                       <i class="fa fa-entry"></i>
                                        <div class="flex-grow-1 checkin"> Check In @ {{item.check_in}} </div>
                                      </div>
                                    </div>
                                    
                                     <div class="your-msg" v-if="item.check_out">
                                      <div class="d-flex">
                                       <i class="fa fa-entry"></i>
                                        <div class="flex-grow-1 checkout"> Check Out @ {{item.check_out}} </div>
                                      </div>
                                    </div>
                                    
                                     
                                  </div>
                                  
                                </div>
                              </div>
                              
                            </div>
                          </div>
                    </div>
                  </div>
                  <div v-else class="noinfo-container">
                    <span class="noinfo">No Past Information Available....</span>
                    </div>
            </div>
          </div>



    </div>  
    
    
    <div class="fixed-bottom bg-light border-top shadow-sm">
      <div class="d-flex justify-content-around text-center py-2">
        <router-link to="/visitorpage" class="text-decoration-none text-dark">
          <div><i class="fa fa-home fa-lg"></i></div>
          <small>Home</small>
        </router-link>
        <router-link to="/ActivePage" class="text-decoration-none text-dark">
          <div><i class="fa fa-bolt fa-lg"></i></div>
          <small>Active</small>
        </router-link>
        <router-link to="/PastPage" class="text-decoration-none text-dark">
          <div><i class="fa fa-history fa-lg"></i></div>
          <small>Past</small>
        </router-link>
       <router-link to="/ProfilePage" class="text-decoration-none text-dark">
          <div><i class="fa fa-user fa-lg"></i></div>
          <small>Profile</small>
        </router-link>
       <a @click="creategatepass" class="text-decoration-none text-dark">
          <div><i class="fa fa-plus-circle fa-lg"></i></div>
          <small>Create</small>
        </a>
      </div>
    </div>

    <span @click="creategatepass" type="button" class="btn  btn-pill btn-secondary createbtn">Create Gatepass</span>


</template>
<style scoped>
.social-chat .flex-grow-1{
        padding: 2px;
}
.social-chat .flex-grow-1:before{
        top: 5px;
}
.createbtn{
  position: fixed;
    right: 0;
    bottom: 0;
    z-index: 999;
}
.page-body{
    margin-left: 0 !important;
    margin-top: 0px!important;
}
.user-profile .hovercard .cardheader{
        height: 70px;
        background: linear-gradient(45deg, #0437c8, #007611);
    }
    @media only screen and (max-width: 575.98px) {
      .tabs-scoial li:nth-child(3) {
          position: sticky;
      }
      .user-profile .hovercard .info{
          padding: 10px;
      }
      .tabs-scoial{
          padding-top: 60px;
      }
    }
.checkin{
  background: #d4ffb4;
}
.checkout{
  background: #dbd7ff;
}
.noinfo-container {
  text-align: center; /* Center the span horizontally */
}
.noinfo{
  text-align: center;
  font-weight: bold; 
}
 
</style>

<script>
// @ is an alias to /src 
import PageTitle from '@/components/PageTitle.vue'; 
// import axios from 'axios';
import axios from "@/plugins/axios";
import QRCode from 'qrcode';
const config = {
            headers: {
               "Content-Type": "application/x-www-form-urlencoded"
            },
            responseType: 'json'
         };
export default {
    name: 'VisitorPage', 
    components: {
        PageTitle 
    }, 
    mounted() {
             
        this.getBasics(0);



        }, 
        data() {
        return {
            visitor: { "name": '', "firmname": '',"contact": '', "purpose": ''},
            visits: [],
            accessories:[],
            addAccessories_passid:'',
            accessories_name:'',
            past_visits:[]
        }
    },
    methods: {  

        getBasics(token,isLocalToke=0) {
            var self = this;
            axios.post('getVisitorProfile').then(function (response) {
                
              if(response.data.is==1){
                localStorage.removeItem('_emp_token');
                self.visitor = response.data.user; 
                
                if(self.visitor.name=='')
                    self.$router.push({ name: "visitorprofile" });   
                    
                self.visits = response.data.visits;  
                self.past_visits = response.data.past_visits;  
                window.scrollTo(0, 0);
              }else if(response.data.is==0){
                localStorage.removeItem('token');
                self.$router.push({ name: "register" });   
              }
              

                
            });
        },
        
       
        checkOutRequest(token) {
            var self = this;
            axios.post('checkOutRequest',{token:token}).then(function (response) {
              if(response.data.is==1){ 
                self.$swal(response.data.msg);
                window.scrollTo(0, 0);
              }  });
        },
        // add_accessories(token) {
        //     var self = this;
        //     axios.post('addGatePasAccessories',{token:localStorage['token'],accessories_passid:this.addAccessories_passid,accessories_name:this.accessories_name}).then(function (response) {
        //       if(response.data.is==1){ 
        //         self.accessories = response.data.accessories; 
        //         window.scrollTo(0, 0);
        //       }  });
        // },
        getImageUrl(image) {
            if(image && !image.includes('.bin'))
                return `${this.$hostname}/writable/visitors/${image}`;
            else
                return `${this.$hostname}/writable/visitors/user.png`;
            },
            
        async getQrCode(token) {
            try {
              if(token.length>0){
                  const canvas = this.$refs.qrcodeCanvas;
                  var url=this.$api_host+'vp?q='+token;
                  //var url= 'http://192.168.1.8:8081/visitorgatepassview?q='+token;
                  await QRCode.toCanvas(canvas,url , { width: 200 });
                  $("#qrcodeView").modal("toggle");
              }
              
            } catch (error) {
              console.error(error);
            }
          }, 
          addAccessories_modal(visit) {
             this.addAccessories_passid=visit.gatepassid;
             if(this.addAccessories_passid>0){
              var self = this;
              axios.post('getAccessories',{token:localStorage['token'],accessories_passid:this.addAccessories_passid,accessories_name:this.accessories_name}).then(function (response) {
                if(response.data.is==1){ 
                    self.accessories = response.data.accessories; 
                    $("#accessoriesModal").modal("toggle");
              }  });
                
                
                 
             }
           
          },
          logout(){
            localStorage.removeItem('token');
            localStorage.removeItem('_emp_token');
            this.$router.push({ name: "register" });  
          },
          creategatepass(){
        //   window.location.assign(window.location.origin + "/visitorcreategatepass");
      
            if(this.visitor.photo && !this.visitor.photo.includes('.bin'))
                this.$router.push({ name: "visitorcreategatepass" }); 
            else
                this.$router.push({ name: "capture" });   
        },


       
    }
}





</script>
